import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ProductSpecificationTileModel } from '@/types/B2BcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import ProductSpecificationsTabs from '@/shared/product/details/ui/product-specifications/ProductSpecificationsTabs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpecificationsTile',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createVNode(ProductSpecificationsTabs, { content: __props.content }, null, 8, ["content"])
    ]),
    _: 1
  }))
}
}

})